export class Gallery {

    /**
     * Convert all post gallery images into Slick slider
     *
     * @public
     */
    static postGallery()
    {
        const $ = jQuery;
        /**
         * @type {number}
         */
        let count = 0;
        /**
         * @type {number}
         */
        let currentSliderSlide = 0;
        /**
         * @type {Event}
         */
        let currentSlick = null;

        // Cpúy gallery to create thumbnails
        $('.wp-block-gallery').each(function(index, value) {
            let $value = $(value);
            let $nav = $('<div></div>')
                .addClass('wp-block-gallery-nav')
                .html($value.html());

            $(value).after($nav);
        });

        const grids = $('.wp-block-gallery .blocks-gallery-grid');
        const gridsNav = $('.wp-block-gallery-nav .blocks-gallery-grid');

        function insertAfter(referenceNode, newNode) {
            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
        }

        $(gridsNav).on('init', function(slick){
            const dots = slick.currentTarget.querySelector('.slick-dots');
            const figcaptionEl = document.createElement('p');
            const parent = slick.currentTarget.parentElement;
            const activeFigcaption = parent.querySelector('.slick-current figcaption');
            let activeSlides = 5;

            figcaptionEl.classList.add('block-gallery-caption');
            insertAfter(parent, figcaptionEl);

            if (activeFigcaption) {
                figcaptionEl.style.display = 'block';
                figcaptionEl.innerHTML = activeFigcaption.innerHTML;
            } else {
                figcaptionEl.style.display = 'none';
            }

            if (window.matchMedia('(min-width:480px)').matches) {
                activeSlides = 7;
            }

            if (dots) {
                const dotsNum = dots.children.length - activeSlides;
                const slides = parent.querySelectorAll('.slick-slide');
                count = parseInt(dotsNum.toString());
                currentSlick = slick;

                Gallery._setCountSlide(currentSlick, count);
            }
        });

        $(gridsNav).on('afterChange', function(slick, currentSlide ){
            const parent = slick.currentTarget.parentElement;
            const activeFigcaption = parent.querySelector('.slick-current figcaption');
            const figcaptionEl = document.querySelector('.block-gallery-caption');

            if (activeFigcaption) {
                figcaptionEl.style.display = 'block';
                figcaptionEl.innerHTML = activeFigcaption.innerHTML;
            } else {
                figcaptionEl.style.display = 'none';
            }
        });

        // Init slider
        $(grids).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite : false,
            fade: true,
            asNavFor: '.wp-block-gallery-nav .blocks-gallery-grid',
        })
            // Change slider count on swipe event
            .on('afterChange', (event, slick, currentSlide, nextSlide) => {
                // Check if last slide is yet active
                const parent = currentSlick.currentTarget.parentElement;
                const slides = parent.querySelectorAll('.slick-slide');
                const lastSlide = slides.item(slides.length - 1);
                let diff = currentSlide - currentSliderSlide;

                diff = diff * (-1);
                count = count + diff;

                // // Check if last item is active/shown in navigation?
                if(lastSlide && lastSlide.classList.contains('slick-active')) {
                    count = 0;
                }

                // Update
                currentSliderSlide = currentSlide;
                Gallery._setCountSlide(currentSlick, count);
        });


        // Slider thumbnails
        $(gridsNav).slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            asNavFor: '.wp-block-gallery .blocks-gallery-grid',
            dots: true,
            centerMode: false,
            infinite : false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                }
            ]
        });


    }

    /**
     * @param {Event} slick
     * @param {int} count
     * @private
     */
    static _setCountSlide(slick, count)
    {
        const parent = slick.currentTarget.parentElement;
        const slides = parent.querySelectorAll('.slick-slide');

        if (slides.length > 0) {

            slides.forEach(slide => {
                const figureEl = slide.querySelector('figure');

                if(count > 0) {
                    figureEl.setAttribute('data-count', '+' + count);
                } else {
                    figureEl.setAttribute('data-count', '');
                }
            });
        }
    }

}